import { render, staticRenderFns } from "./Clothes.vue?vue&type=template&id=3de98312&scoped=true&"
import script from "./Clothes.vue?vue&type=script&lang=js&"
export * from "./Clothes.vue?vue&type=script&lang=js&"
import style0 from "./Clothes.vue?vue&type=style&index=0&id=3de98312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de98312",
  null
  
)

export default component.exports